var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Col',{attrs:{"cols":"12"}},[_c('Link',{staticClass:"ml-3",attrs:{"blank":"","color":"primary","href":"https://ajuda.locaweb.com.br/wiki/configurando-o-dominio-criador-de-sites/"},domProps:{"textContent":_vm._s(_vm.lc.knowHow)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }